import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import React from 'react';

import { petrol, yellow } from '../../../styles/mui/colors';
import useAppSelector from '../../../util/hooks/useAppSelector';
import ProgressiveImage from '../../Image/ProgressiveImage';

const AnnualPassAd = ({ blok }) => {
  const { dataSource } = blok;

  const fetchingInProgress = useAppSelector((state) => state.StoryblokPage.fetchStoryPresetsInProgress);

  if (fetchingInProgress || !dataSource) {
    return (<Grid container>
      <Grid size={12}>
        <Skeleton height={500} variant="rectangular" width="100%" />
      </Grid>
    </Grid>);
  }

  const { heading, subHeading, body1, imageUrl, buttonLabel, buttonLink } = dataSource;


  return (
    <Grid container>
      <Grid size={12}>
        <Typography
          component="h2"
          sx={{ backgroundColor: petrol.main, color: 'white', fontWeight: 'bold' }}
          variant="h3"
        >
          {heading}
        </Typography>
        <Typography
          component="h3"
          gutterBottom
          sx={{ backgroundColor: yellow.main, color: petrol.main }}
          variant="h3"
        >
          {subHeading}
        </Typography>
        <Typography component="h3" sx={{ fontWeight: 'normal' }} variant="body2">
          {body1}
        </Typography>
        <Grid size={12}>
          <ProgressiveImage
            alt="annual pass alt"
            disableBlur
            src={imageUrl}
            title="annual pass image"
          />
        </Grid>

        <Grid container justifyContent="center">
          <Button color="primary" href={buttonLink} sx={{ marginTop: '16px' }} variant="contained">
            {buttonLabel}
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AnnualPassAd;
